import { API } from '@ax/api';
import { API_SERVICES } from './utils';
import {
  RequestPasswordRequestApiParams,
  RequestPasswordRequestApiResponse,
} from './signup-interface';

export const requestPasswordRequestApi = async ({
  email,
}: RequestPasswordRequestApiParams): Promise<RequestPasswordRequestApiResponse> => {
  const res = await API.get(API_SERVICES.SIGNUP_API, `/go/request-password-reset`, {
    params: {
      email,
    },
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
};
